import { TEXTS } from '../data/texts.js';
import { Capacitor } from '@capacitor/core';

export const SUPPORTED_LANGS = ['en', 'it'];

const extractLangCode = (locale) =>
  (typeof locale === 'string' ? locale : '').split(/[-_]/)[0].toLowerCase() || 'en';

let currentLang = extractLangCode(
  typeof navigator !== 'undefined' ? navigator.language : ''
);

export const initLanguage = async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      const { Device } = await import('@capacitor/device');
      const { value } = await Device.getLanguageCode();
      currentLang = extractLangCode(value);
      return;
    } catch {
      // fall through to browser detection
    }
  }
  currentLang = extractLangCode(
    typeof navigator !== 'undefined' ? navigator.language : ''
  );
};

export const t = (key) => {
  const entry = TEXTS[key];
  if (!entry) return key;
  return entry[currentLang] ?? entry.en ?? key;
};

export function useText() {
  return { t };
}
